var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoInline = function SvgLogoInline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 186 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo-inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "m8.75 14.96 8.751 8.64-8.75 8.64L0 23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E83E30",
    d: "M15.098 8.693 23.902 0 39 14.907 30.195 23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M14.693 39.067 23.633 48 39 32.64V14.747z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#E83E30",
    clipPath: "url(#logo-inline_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63 9.425h10.94c8.68 0 14.72 5.794 14.72 14.541s-6.04 14.497-14.72 14.497H63zM73.94 33.05c5.48 0 8.68-4.139 8.68-9.06s-2.998-9.105-8.68-9.105h-5.034v18.165zM94.924 9.425h19.62v5.324H100.83v6.332h13.423v5.324H100.83v6.756h13.714v5.37h-19.62zM132.374 27.86l-6.98 10.626h-7.025l10.067-14.9-9.44-14.16h7.024l6.354 9.932 6.286-9.933h7.114l-9.441 14.116L146.4 38.486h-7.069l-6.935-10.627zM151.054 9.425h5.906v29.06h-5.906zM165.841 29.671c1.946 2.148 4.989 3.915 8.814 3.915 3.244 0 4.81-1.61 4.81-3.266 0-2.192-2.416-2.908-5.615-3.714-4.519-1.096-10.358-2.393-10.358-8.881 0-4.832 3.982-8.747 10.515-8.747 4.407 0 8.053 1.387 10.805 4.049l-3.289 4.519c-2.237-2.192-5.234-3.177-7.941-3.177s-4.072 1.23-4.072 2.953c0 1.947 2.327 2.573 5.526 3.356 4.564 1.096 10.402 2.528 10.402 8.97 0 5.325-3.624 9.33-11.096 9.33-5.324 0-9.15-1.88-11.767-4.609l3.244-4.698z"
  })))));
};
export default SvgLogoInline;